document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.colfilter-title-wrapper').forEach(function(titleWrapper) {
    titleWrapper.addEventListener('click', function() {
      const container = titleWrapper.nextElementSibling;
      container.classList.toggle('active');
      titleWrapper.setAttribute('aria-expanded', container.classList.contains('active') ? 'true' : 'false');

      const chevron = titleWrapper.querySelector('i');
      if (chevron.classList.contains('bi-dash-lg')) {
        chevron.classList.remove('bi-dash-lg');
        chevron.classList.add('bi-plus-lg');
      } else {
        chevron.classList.remove('bi-plus-lg');
        chevron.classList.add('bi-dash-lg');
      }
    });

    titleWrapper.addEventListener('keydown', function(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      titleWrapper.click();
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const openFilterBtn = document.querySelector('.colfilter-btn-wrapper');
  const toggleButton = openFilterBtn ? openFilterBtn.querySelector('button') : null;
  const drawer = document.querySelector('.collection-filters');
  const backdrop = document.querySelector('.collection-filter-bck');
  const closeFilterBtn = document.querySelector('.colfil-close-button');
  if (!openFilterBtn || !drawer) return;

  const drawerQuery = window.matchMedia('(max-width: 1249px)');

  const focusables = function() {
    return Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]')).filter(function(element) {
      return element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden';
    });
  };

  const setDialog = function(on) {
    if (on) {
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      drawer.setAttribute('aria-label', 'Filters');
    } else {
      drawer.removeAttribute('role');
      drawer.removeAttribute('aria-modal');
      drawer.removeAttribute('aria-label');
    }
  };

  const openDrawer = function() {
    drawer.classList.add('active');
    if (backdrop) backdrop.classList.add('active');
    if (toggleButton) toggleButton.setAttribute('aria-expanded', 'true');
    if (!drawerQuery.matches) return;
    setDialog(true);
    setTimeout(function() {
      const target = closeFilterBtn || focusables()[0];
      if (target) target.focus();
    }, 50);
  };

  const closeDrawer = function() {
    const wasOpen = drawer.classList.contains('active');
    drawer.classList.remove('active');
    if (backdrop) backdrop.classList.remove('active');
    if (toggleButton) toggleButton.setAttribute('aria-expanded', 'false');
    setDialog(false);
    if (wasOpen && toggleButton && drawerQuery.matches) toggleButton.focus();
  };

  openFilterBtn.addEventListener('click', openDrawer);
  if (closeFilterBtn) closeFilterBtn.addEventListener('click', closeDrawer);

  drawer.addEventListener('keydown', function(event) {
    if (!drawer.classList.contains('active') || !drawerQuery.matches) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab') return;
    const items = focusables();
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  const onModeChange = function() {
    if (!drawerQuery.matches) setDialog(false);
  };
  if (drawerQuery.addEventListener) {
    drawerQuery.addEventListener('change', onModeChange);
  } else if (drawerQuery.addListener) {
    drawerQuery.addListener(onModeChange);
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const storeKey = 'collectionFilterFocus';
  const results = document.getElementById('CollectionResults');
  const status = document.getElementById('CollectionFilterStatus');

  const normalizePath = function(path) {
    try {
      path = decodeURIComponent(path);
    } catch (error) {}
    return path.toLowerCase().replace(/\/+$/, '');
  };

  const isShown = function(element) {
    if (!element || !element.getClientRects().length) return false;
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.left < window.innerWidth;
  };

  const moveFocus = function(target, block) {
    if (document.activeElement === target) target.blur();
    target.setAttribute('data-focus-restored', '');
    target.focus({ preventScroll: true });
    target.addEventListener('blur', function() {
      target.removeAttribute('data-focus-restored');
    }, { once: true });
    target.scrollIntoView({ block: block });
  };

  const skipLink = document.querySelector('.collection-skip-link');
  if (skipLink && results) {
    skipLink.addEventListener('click', function(event) {
      event.preventDefault();
      moveFocus(results, 'start');
    });
  }

  document.addEventListener('click', function(event) {
    const link = event.target.closest('.collection-filters .filter-label a, .filter-selvalues a');
    if (!link) return;

    const row = link.closest('.filter-value');
    const named = link.closest('[data-filter-name]');
    let action = 'remove';
    if (link.closest('[data-filter-clear]')) {
      action = 'clear';
    } else if (row && !row.classList.contains('active')) {
      action = 'add';
    }

    const data = {
      path: normalizePath(new URL(link.href, window.location.href).pathname),
      handle: row ? row.getAttribute('data-filter-handle') : '',
      name: named ? named.getAttribute('data-filter-name') : '',
      action: action,
      time: Date.now()
    };

    try {
      sessionStorage.setItem(storeKey, JSON.stringify(data));
    } catch (error) {}
  });

  let saved = null;
  try {
    saved = JSON.parse(sessionStorage.getItem(storeKey) || 'null');
    sessionStorage.removeItem(storeKey);
  } catch (error) {}

  if (!saved || Date.now() - saved.time > 30000 || saved.path !== normalizePath(window.location.pathname)) return;

  let target = null;
  if (saved.handle) {
    const handle = window.CSS && CSS.escape ? CSS.escape(saved.handle) : saved.handle;
    const row = document.querySelector('.collection-filters .filter-value[data-filter-handle="' + handle + '"]');
    const rowLink = row ? row.querySelector('.filter-label a') : null;
    if (isShown(rowLink)) target = rowLink;
  }

  const focusTarget = target || results;
  const block = target ? 'center' : 'start';
  if (focusTarget) moveFocus(focusTarget, block);

  let interrupted = false;
  const stop = function() {
    interrupted = true;
  };
  ['keydown', 'pointerdown', 'wheel', 'touchstart'].forEach(function(type) {
    document.addEventListener(type, stop, { once: true, capture: true, passive: true });
  });

  let message = 'Filters updated.';
  if (saved.action === 'clear') {
    message = 'All filters cleared.';
  } else if (saved.name) {
    message = saved.name + ' filter ' + (saved.action === 'add' ? 'applied.' : 'removed.');
  }
  const count = status ? parseInt(status.getAttribute('data-products-count'), 10) : NaN;
  const countText = isNaN(count) ? '' : ' ' + count + (count === 1 ? ' product.' : ' products.');

  let settled = false;
  const settle = function() {
    if (settled) return;
    settled = true;
    if (focusTarget && !interrupted) moveFocus(focusTarget, block);
    if (status) {
      setTimeout(function() {
        status.textContent = message + countText;
      }, 1000);
    }
  };

  const afterLoad = function() {
    setTimeout(settle, 1000);
  };
  if (document.readyState === 'complete') {
    afterLoad();
  } else {
    window.addEventListener('load', afterLoad, { once: true });
  }
  setTimeout(settle, 10000);
});
